(function () {
  function syncFocusability(card) {
    var hidden = card.getAttribute('aria-hidden') === 'true';
    card.querySelectorAll('a[href], button, input, textarea, select, [tabindex]').forEach(function (el) {
      if (hidden) {
        if (!el.hasAttribute('data-jdgm-a11y-tabindex')) {
          el.setAttribute('data-jdgm-a11y-tabindex', el.getAttribute('tabindex') || '');
        }
        el.setAttribute('tabindex', '-1');
      } else if (el.hasAttribute('data-jdgm-a11y-tabindex')) {
        var original = el.getAttribute('data-jdgm-a11y-tabindex');
        if (original) {
          el.setAttribute('tabindex', original);
        } else {
          el.removeAttribute('tabindex');
        }
        el.removeAttribute('data-jdgm-a11y-tabindex');
      }
    });
  }

  function scan(root) {
    root.querySelectorAll('.jdgm-carousel-item').forEach(syncFocusability);
  }

  document.addEventListener('DOMContentLoaded', function () {
    scan(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          var target = mutation.target;
          if (target.classList && target.classList.contains('jdgm-carousel-item')) {
            syncFocusability(target);
          }
        } else if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              if (node.classList && node.classList.contains('jdgm-carousel-item')) {
                syncFocusability(node);
              }
              scan(node);
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
      childList: true,
      subtree: true
    });
  });
})();
